<template>
<div class="help">
  <!--头部导航-->
  <top-nav ref="TopNav"></top-nav>
  <van-nav-bar title="帮助中心" fixed left-arrow @click-left="goBack" @click-right="onClickRight">
    <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
  </van-nav-bar>
  <div id="helpList" class="van-content">
    <van-collapse v-model="activeName" accordion>
        <van-collapse-item  v-for="(items,index) in datas" :key="items.id" :title="items.name"  :name="items.index">
          <p style="margin-bottom: 8px;padding-left: 15px" v-for="(item,index) in items.content" :key="item.id">
            <router-link style="color: #999" :to="{path:'/user/helpDetail',query:{id:item.id}}">{{item.name}}</router-link>
          </p>
        </van-collapse-item>
    </van-collapse>
  </div>
</div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "index",
    components: {
      TopNav
    },
    data (){
      return {
        datas:'',
        activeName: ['1']
      }
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      getDatas:function () {
        this.$api.post('/WebApi/Article/Index/index', null, res => {
          if (res.data.code == '100') {
            this.datas= res .data.data
          }
        })
      }
    },
    mounted () {
      this.getDatas()
    },

  }
</script>

<style scoped>
  #helpList{
   padding-top: 55px;
  }
  #helpList .van-collapse-item{
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/help/index.vue